import { createElement } from "react";

import LoginPage from "pages/LoginPage";
import VerifyDevicePage from "pages/VerifyDevicePage";
import HomePage from "pages/HomePage";
import GiftExchangePage from "pages/GiftExchangePage";
import UserPage from "pages/UserPage";
import SpecialOfferPage from "pages/SpecialOfferPage";
import GamePage from "pages/GamePage";
import VerifyPage from "pages/VerifyPage";
import CartsPage from "pages/CartsPage";
import ErrorPage from "pages/ErrorPage";
import OrderHistoryPage from "pages/OrderHistoryPage";
import ChangePasswordPage from "pages/ChangePasswordPage";
import InfomationStorePage from "pages/InfomationStorePage";
import PromotionDetailPage from "pages/PromotionDetailPage";
import LoyaltyDetailPage from "pages/LoyaltyDetailPage";
import OrderHistoryDetailPage from "pages/OrderHistoryDetailPage";
import SplashPage from "pages/SplashPage";
import RegisterPage from "pages/RegisterPage";
import CreatePassword from "pages/CreatePassword";
import InfoLoyalty from "pages/InfoLoyalty";
import DeleteAccountPage from "pages/DeleteAccountPage";
import FeedBackPage from "pages/FeedBackPage";
import NotificationPage from "pages/NotificationPage";
import NewsPage from "pages/NewsPage";
import NetworkErrorPage from "pages/NetworkError";
import NotFound from "pages/404";
import FindProduct from "pages/FindProduct";
import SignaturePage from "pages/SignaturePage";
import MerchandisingDetailPage from "pages/MerchandisingDetailPage";

export const mockupRouter = [
	{
		type: "LOGIN",
		path: "/",
		isAuth: false
	},
	{
		type: "SPLASH",
		path: "/splash",
		isAuth: false
	},
	{
		type: "CREATE_PASSWORD",
		path: "/create_password",
		isAuth: false
	},
	{
		type: "REGISTER",
		path: "/register",
		isAuth: false
	},
	{
		type: "VERIFY_DEVICE",
		path: "/verify-device",
		isAuth: false
	},
	{
		type: "HOME",
		path: "/home",
		isAuth: true
	},
	{
		type: "GIFT_EXCHANGE",
		path: "/gift_exchange",
		isAuth: true
	},
	{
		type: "USER",
		path: "/user",
		isAuth: true
	},
	{
		type: "SPECIAL_OFFER",
		path: "/special_offer",
		isAuth: true
	},
	{
		type: "GAME",
		path: "/games",
		isAuth: false
	},
	{
		type: "ACCOUNT_VERIFY",
		path: "/account_verify",
		isAuth: true
	},
	{
		type: "CART",
		path: "/carts",
		isAuth: true
	},
	{
		type: "ERROR",
		path: "/error",
		isAuth: true
	},
	{
		type: "ORDER_HISTORY",
		path: "/order_history",
		isAuth: true
	},
	{
		type: "CHANGE_PASSWORD",
		path: "/change_password",
		isAuth: true
	},
	{
		type: "INFOMATION_STORE",
		path: "/information_store",
		isAuth: true
	},
	{
		type: "PROMOTION_DETAIL",
		path: "/promotion_detail",
		isAuth: true
	},
	{
		type: "LOYALTY_DETAIL",
		path: "/special_offer_detail",
		isAuth: true
	},
	{
		type: "ORDER_HISTORY_DETAIL",
		path: "/order_history_detail",
		isAuth: true
	},
	{
		type: "INFO_LOYALTY",
		path: "/info_loyalty",
		isAuth: true
	},
	{
		type: "DELETE_ACCOUNT",
		path: "/delete_account",
		isAuth: true
	},
	{
		type: "FEEDBACK",
		path: "/feed_back",
		isAuth: true
	},
	{
		type: "NOTIFICATION",
		path: "/notification",
		isAuth: true
	},
	{
		type: "SIGNATURE",
		path: "/signature",
		isAuth: true
	},
	{
		type: "NEWS",
		path: "/news",
		isAuth: true
	},
	{
		type: "FIND_PRODUCT",
		path: "/find_product",
		isAuth: true
	},
	{
		type: "MERCHANDISING_DETAIL",
		path: "/merchandising_detail",
		isAuth: true
	},
	{
		type: "NETWORK_ERROR",
		path: "/network_error",
		isAuth: false
	},
	{
		type: "404",
		path: "/404",
		isAuth: false
	}
];

export const renderComponent = (type, props) => {
	switch (type) {
		case "LOGIN":
			return createElement(LoginPage, props);
		case "SPLASH":
			return createElement(SplashPage, props);
		case "CREATE_PASSWORD":
			return createElement(CreatePassword, props);
		case "REGISTER":
			return createElement(RegisterPage, props);
		case "HOME":
			return createElement(HomePage, props);
		case "VERIFY_DEVICE":
			return createElement(VerifyDevicePage, props);
		case "GIFT_EXCHANGE":
			return createElement(GiftExchangePage, props);
		case "USER":
			return createElement(UserPage, props);
		case "SPECIAL_OFFER":
			return createElement(SpecialOfferPage, props);
		case "GAME":
			return createElement(GamePage, props);
		case "ACCOUNT_VERIFY":
			return createElement(VerifyPage, props);
		case "CART":
			return createElement(CartsPage, props);
		case "ERROR":
			return createElement(ErrorPage, props);
		case "ORDER_HISTORY":
			return createElement(OrderHistoryPage, props);
		case "CHANGE_PASSWORD":
			return createElement(ChangePasswordPage, props);
		case "INFOMATION_STORE":
			return createElement(InfomationStorePage, props);
		case "PROMOTION_DETAIL":
			return createElement(PromotionDetailPage, props);
		case "LOYALTY_DETAIL":
			return createElement(LoyaltyDetailPage, props);
		case "ORDER_HISTORY_DETAIL":
			return createElement(OrderHistoryDetailPage, props);
		case "INFO_LOYALTY":
			return createElement(InfoLoyalty, props);
		case "DELETE_ACCOUNT":
			return createElement(DeleteAccountPage, props);
		case "FEEDBACK":
			return createElement(FeedBackPage, props);
		case "NOTIFICATION":
			return createElement(NotificationPage, props);
		case "SIGNATURE":
			return createElement(SignaturePage, props);
		case "NEWS":
			return createElement(NewsPage, props);
		case "FIND_PRODUCT":
			return createElement(FindProduct, props);
		case "MERCHANDISING_DETAIL":
			return createElement(MerchandisingDetailPage, props);
		case "NETWORK_ERROR":
			return createElement(NetworkErrorPage, props);
		case "404":
			return createElement(NotFound, props);
		default:
		// do nothing
	}
};
